import{ADDRESS_SCHEMA as l}from"./constants.js";const n=(n,o,t)=>l.includes(n)?(null==t?void 0:t[n])?o.get(null==t?void 0:t[n]):o.get(n):null;export{n as mapFieldKey};
//# sourceMappingURL=utils.js.map
